import { useState } from 'react';
import { useDeals } from '../store/DealsContext';
import { Document } from '../types';

export function useFileUpload() {
  const { addDocument } = useDeals();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadFiles = async (files: File[], dealId: string) => {
    setUploading(true);
    setError(null);

    try {
      for (const file of files) {
        const newDocument: Document = {
          id: crypto.randomUUID(),
          dealId,
          name: file.name,
          type: file.type,
          uploadDate: new Date().toISOString(),
          lastModified: new Date().toISOString(),
          size: file.size,
          path: `/documents/${dealId}/`,
          permissions: ['view', 'download'],
          version: 1,
          status: 'draft'
        };

        // In a real app, you would upload the file to a server here
        await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate upload
        addDocument(newDocument);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to upload files');
    } finally {
      setUploading(false);
    }
  };

  return { uploadFiles, uploading, error };
}